<template>
  <section id="home-sub-banner">
    <b-container>
      <b-row>
        <b-col cols="12">
          <h2 class="content-section-title">New Released</h2>
          <h3>K4 (Carbon Fiber+Silicone Ceramic)</h3>
          <ul>
            <li>Silicone Ceramic Coating for 3X Durable</li>
            <li>Patented Multifunctional Base Design</li>
            <li>Mute the noices, enjoy the silence</li>
          </ul>
          <router-link :to="{ name: 'product', params: { name: 'knight4cf' } }" class="btn btn-sp">Take A Look</router-link>
        </b-col>
      </b-row>
      </b-container>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#home-sub-banner {
  padding: 50px 0;
  background-image: url("~@/assets/images/home/new_bg_01.jpg");
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  .content-section-title {
    color: #fff;
    text-align: left;
  }
  h3 {
    margin-bottom: 30px;
    font-size: 36px !important;
  }
  ul {
    margin-bottom: 30px;
  }
  ul li {
    list-style-type: disc;
    list-style-position: inside;
    font-size: 18px;
    line-height: 30px;
  }
  .btn-sp {
    padding: 14px 29px;
    color: #fff;
    border: 1px solid #fff;
  }
}
</style>